import * as React from "react";

import type { VariantProps } from "class-variance-authority";

import { cva } from "class-variance-authority";

import { cn } from "../../utils";

const badgeVariants = cva(
  "af-inline-flex af-items-center af-rounded-full af-border af-px-2.5 af-py-0.5 af-text-xs af-font-semibold af-transition-colors focus:af-outline-none focus:af-ring-2 focus:af-ring-ring focus:af-ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "af-border-transparent af-bg-primary af-text-primary-foreground hover:af-bg-primary/80",
        secondary:
          "af-border-transparent af-bg-secondary af-text-secondary-foreground hover:af-bg-secondary/80",
        destructive:
          "af-border-transparent af-bg-destructive-foreground af-text-destructive hover:af-bg-destructive/20",
        outline: "af-border-border af-text-foreground",
        success:
          "af-border-transparent af-bg-success-accent af-text-primary-foreground hover:af-bg-success-accent/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
